import { Alert } from '../../components/Primitives.jsx';

// ── Shared pass-through note (used by aggregate/join/reshape/enrich) ───
export function PassthroughNote({ what }) {
  return (
    <Alert kind="info" style={{ marginTop: 14 }}>
      <strong>Preview pass-through.</strong> {what.charAt(0).toUpperCase() + what.slice(1)}
      &nbsp;executes against the production engine at run time; the in-app
      preview leaves the input rows untouched so you can keep configuring
      downstream steps.
    </Alert>
  );
}
